import { render } from "./ConfigTastesEditor.vue?vue&type=template&id=4c409b9e"
import script from "./ConfigTastesEditor.vue?vue&type=script&lang=js"
export * from "./ConfigTastesEditor.vue?vue&type=script&lang=js"

import "./ConfigTastesEditor.vue?vue&type=style&index=0&id=4c409b9e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__